import { Toaster as Sonner, type ToasterProps } from "sonner";
import { useIsMobile } from "@/hooks/use-mobile";

// ponytail: no next-themes; theme follows the OS until a theme setting exists (Settings slice).
function Toaster(props: ToasterProps) {
  const isMobile = useIsMobile();
  return (
    <Sonner
      theme="system"
      position={isMobile ? "top-center" : "bottom-right"}
      duration={5000}
      className="toaster group"
      toastOptions={{ classNames: { toast: "rounded-full shadow-lg" } }}
      style={
        {
          "--normal-bg": "var(--foreground)",
          "--normal-text": "var(--background)",
          "--normal-border": "var(--foreground)",
          "--border-radius": "9999px",
        } as React.CSSProperties
      }
      {...props}
    />
  );
}

export { Toaster };
